import { format } from "date-fns";
import { Fragment, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { activityOptions, resultOptions, valutatoreOptions } from "../../../../utils";
import { GetByIdPersonalManagement } from "../../slice";
import { EvaluationUpdate, EvaluationValidation, resetEvaluationError, resetEvaluationUpdateRequest, resetEvaluationUpdateStatus, resetEvaluationValidationStatus, setUpdateEvaluationActivityId, setUpdateEvaluationDate, setUpdateEvaluatorId, setUpdateNote, setUpdateResult } from "../slice";

interface Props {
    close: () => void;
}

export function ValutazioniPopupEdit(props: Props) {
    const evaluationState = useAppSelector(state => state.PMEvaluations);
    const PMState = useAppSelector(state => state.personalManagement);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (evaluationState.evaluationValidationStatus === 'successfully') {
            dispatch(resetEvaluationValidationStatus());
            dispatch(resetEvaluationError());
            dispatch(EvaluationUpdate({ body: evaluationState.evaluationUpdateRequest, id: evaluationState.evalIdToUpdate }));
        }
    }, [evaluationState.evaluationValidationStatus]);

    useEffect(() => {
        if (evaluationState.evaluationUpdateStatus === 'successfully') {
            dispatch(resetEvaluationUpdateStatus());
            dispatch(resetEvaluationUpdateRequest());
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!));
            props.close();
        }
    }, [evaluationState.evaluationUpdateStatus]);

    return (
        <Fragment>
            <div className="p-6 bg-white flex flex-col gap-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Calendar
                        label="Data valutazione"
                        selected={evaluationState.evaluationUpdateRequest.evaluationDate}
                        onChange={(date) => {
                            dispatch(setUpdateEvaluationDate(format(new Date(date), 'yyyy-MM-dd')));
                        }}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Attività da valutare"
                        placeholder="Attività da valutare"
                        options={activityOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null;
                            dispatch(setUpdateEvaluationActivityId(newValue));
                        }}
                        value={evaluationState.evaluationUpdateRequest.evaluationActivityId}
                        error={evaluationState.evaluationError.evaluationActivityId}
                        errorLabel="Attività mancante"
                        noOptionsMessage={""}
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Valutatore"
                        placeholder="Valutatore"
                        options={valutatoreOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null;
                            dispatch(setUpdateEvaluatorId(newValue));
                        }}
                        value={evaluationState.evaluationUpdateRequest.evaluatorId}
                        error={evaluationState.evaluationError.evaluatorId}
                        errorLabel="Valutatore mancante"
                        noOptionsMessage={""}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Esito"
                        placeholder="Esito"
                        options={resultOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null;
                            dispatch(setUpdateResult(newValue));
                        }}
                        value={evaluationState.evaluationUpdateRequest.result}
                        error={evaluationState.evaluationError.result}
                        errorLabel="Esito mancante"
                        noOptionsMessage={""}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Note sulla valutazione"
                        defaultValue={evaluationState.evaluationUpdateRequest.note}
                        value={evaluationState.evaluationUpdateRequest.note}
                        onChangeText={(text) => dispatch(setUpdateNote(text))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => {
                            dispatch(resetEvaluationError());
                            dispatch(resetEvaluationUpdateRequest());
                            props.close();
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            dispatch(EvaluationValidation(evaluationState.evaluationUpdateRequest));
                        }}
                    />
                </div>
            </div>
        </Fragment>
    );
}